import React from 'react'
import Close from '../assets/close.svg?react'

interface IFullScreenDialogProps {
  isOpen: boolean
  onClose: () => void
  children: React.ReactNode
}

export const FullScreenDialog = (props: IFullScreenDialogProps) => {
  if (!props.isOpen) return null

  return (
    <div
      className={
        'fixed inset-0 z-50 bg-black bg-opacity-70 flex items-center justify-center'
      }
    >
      <div className={'bg-white w-full h-full overflow-auto relative'}>
        <button
          onClick={props.onClose}
          className={
            'absolute top-8 right-8 cursor-pointer'
          }
        >
          <Close width={20} height={20} />
        </button>
        {props.children}
      </div>
    </div>
  )
}
